<template>
  <div>
    <div class="back" v-if="$route.name != 'Home'" @click="$router.go(-1)">
      <img src="@/assets/img/back.svg" />
      <p>back</p>
    </div>
    <!-- <img src="@/assets/img/lcg-logo.png" class="fm-logo" /> -->
    <div class="logo-slide" :class="{swipe: swipe}">
      <transition name="fade">
        <img v-if="swipe" :src="client.logo" />
      </transition>
    </div>
  </div>
</template>

<script>
import { db, auth } from "@/config/firebaseInit";
var moment = require("moment");
var tz = require("moment-timezone");

export default {
  name: "heading",
  components: {},
  computed: {
    client() {
      return this.$store.state.client;
    }
  },
  data() {
    return {
      swipe: false
      // client: this.$store.state.client
    };
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>

<style lang='scss'>
.logo-slide {
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  height: 100%;
  background: white;
  width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: width 0.5s;
  img {
    height: 300px;
  }

  &.swipe {
    width: 100%;
  }
}

.fm-logo {
  padding: 20px;
  right: 0;
  position: absolute;
  top: 0;
  z-index: 2;
  max-width: 450px;
  filter: brightness(0.972);
  @media screen and (max-width: 700px) {
    width: 90%;
    padding: 0;
    right: 50%;
    transform: translateX(50%);
  }
}
</style>
